import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Session from './store/session'
import TextFormat from './store/format'

import Vue3Lottie from 'vue3-lottie'
import Toast from "vue-toastification";
import VueAwesomePaginate from "vue-awesome-paginate";
import Datepicker from '@vuepic/vue-datepicker';

import '@vuepic/vue-datepicker/dist/main.css';
import "vue-toastification/dist/index.css";
import 'vue3-lottie/dist/style.css'
import "vue-awesome-paginate/dist/style.css";

// Initialize Sentry
import * as Sentry from "@sentry/vue";

const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://c8f3bf41aebe8b5e05ddc8cfcd6f3e1d@o4508654922440704.ingest.us.sentry.io/4508655005900800",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Capture a test message to verify Sentry setup
//Sentry.captureMessage("Hello Sentry");

app.use(store)
app.use(router)
app.use(Vue3Lottie)
app.use(Session)
app.use(Toast, options);
app.use(VueAwesomePaginate)

app.component('Datepicker', Datepicker)

app.config.globalProperties.$session = Session;
app.config.globalProperties.$format = TextFormat;

app.mount('#app')
